import colorString from "color-string";

export default function colorToHex(color): string {
  return colorString.to.hex(color.rgb().array().map(Math.round));
}
